<template>

    <!--作业完成率-->
    <div>
        <div slot="header" class="clearfix">
            <span>作业完成率</span>
        </div>
        <el-row>
            <el-col :span="6">
                <div class="bg-grey margin-top-10 listname">
                    <el-tag type="danger" effect="plain">前三名</el-tag>
                    <p style="margin-top: 20px">
                        <Tooltip4SortWith :levelArr="topFirst"
                                          fontClass="margin-l-10 bold orange-font"></Tooltip4SortWith>
                    </p>
                    <p>
                        <Tooltip4SortWith :levelArr="topSecond"
                                          fontClass="margin-l-10 bold orange-font"></Tooltip4SortWith>
                    </p>
                    <p>
                        <Tooltip4SortWith :levelArr="topThird"
                                          fontClass="margin-l-10 bold orange-font"></Tooltip4SortWith>
                    </p>
                </div>
                <div class="bg-grey margin-top-20 listname">
                    <el-tag type="danger" effect="plain">后三名</el-tag>
                    <p style="margin-top: 20px">
                        <Tooltip4SortWith :levelArr="lastFirst"
                                          fontClass="margin-l-10 bold orange-font"></Tooltip4SortWith>
                    </p>
                    <p>
                        <Tooltip4SortWith :levelArr="lastSecond"
                                          fontClass="margin-l-10 bold orange-font"></Tooltip4SortWith>
                    </p>
                    <p>
                        <Tooltip4SortWith :levelArr="lastThird"
                                          fontClass="margin-l-10 bold orange-font"></Tooltip4SortWith>
                    </p>
                </div>
            </el-col>
            <el-col :span="18">
                <div ref="completionChart" style="height:320px;width:100%;">
                </div>
            </el-col>

        </el-row>
        <p class="bold" style="margin-top:30px;">数据中心日常作业工单</p>
        <el-row :gutter="20">
            <el-col :span="8">
                <div class="text-center task">
                    <p class="orange-font bold font-18">{{totalAll}}</p>
                    <p class="grey-font">工单总数</p>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="text-center task">
                    <p class="red-font bold font-18">{{overTimeTotalAll}}</p>
                    <p class="grey-font">超时完工工单总数</p>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="text-center task">
                    <p class="blue-font bold font-18">{{totalAll-closedAll}}</p>
                    <p class="grey-font">未完成工单总数</p>
                </div>
            </el-col>
        </el-row>
    </div>

</template>

<script>
    import echarts from "echarts";
    import {WorkOrderServer} from "@/api";
    import {formatDate} from "element-ui/src/utils/date-util";
    import Tooltip4SortWith from "@/views/board/boss/tooltip4SortWith";

    let that;

    export default {
        name: "index",

        components: {
            Tooltip4SortWith,
        },

        props: {
            dcnumids: {
                type: Array,
            },
            dcnumMap: null,
            searchDate: {
                type: String,
                default() {
                    return formatDate(new Date(), 'yyyy-MM');
                }
            },
        },

        data() {
            return {

                dcnumNames: [],

                totalAll: 0,   //工单总数

                overTimeTotalAll: 0,    //超时完工工单总数

                closedAll: 0,     //完成工单总数

                finishRate: new Map(),  //各数据中心的工单完工率

                topFirst: [],
                topSecond: [],
                topThird: [],

                lastFirst: [],
                lastSecond: [],
                lastThird: [],

            }
        },

        methods: {
            query() {
                if (this.dcnumids.length > 0) {
                    let params = {
                        'roomIds': this.dcnumids,
                        'month': this.searchDate,
                    }
                    let month = this.searchDate.split('-')[1];
                    month = month.startsWith(0) ? month.toString().substring(1, 2) : month;

                    let totalAll = [];
                    let closedAll = [];
                    let overTime = 0;
                    let finishRate = 0;
                    let finishRateArr = [];
                    let dataArr = [];   //每个机房的工单完成率
                    this.finishRate = new Map();

                    this.topFirst = [];
                    this.topSecond = [];
                    this.topThird = [];
                    this.lastFirst = [];
                    this.lastSecond = [];
                    this.lastThird = [];

                    WorkOrderServer.workOrder.monthReportWork(params).then(res => {
                        that.dcnumNames = [];

                        for (let i = 0; i < res.length; i++) {
                            that.dcnumNames.push(that.dcnumMap.get(res[i].roomId + ''));

                            overTime += res[i].overtimeCount;

                            let total = 0;
                            let close = 0;
                            for (let key in res[i].workTypeCount) {
                                total += res[i].workTypeCount[key].total;
                                close += res[i].workTypeCount[key].close;
                            }

                            finishRate = (close / total * 100).toFixed(2);
                            finishRateArr.push(finishRate);
                            dataArr.push({
                                'dcnumName': that.dcnumMap.get(res[i].roomId + ''),
                                'finishRate': finishRate,
                            });

                            totalAll.push(total);
                            closedAll.push(close);
                        }

                        this.renderChart(that.dcnumNames, finishRateArr, month);

                        this.totalAll = totalAll.reduce((a, b) => a + b, 0);
                        this.closedAll = closedAll.reduce((a, b) => a + b, 0);
                        this.overTimeTotalAll = overTime;

                        that.getTopLastThree(dataArr);
                    });
                } else {
                    this.renderChart([], [], month);
                    this.totalAll = 0;
                    this.closedAll = 0;
                    this.overTimeTotalAll = 0;
                }
            },

            /**
             * 根据数据中心工单完成率排序，获取前三、后三名称
             * @param dataArr
             */
            getTopLastThree(orgDataArr) {
                orgDataArr = orgDataArr.map(e => {
                    e.finishRate = parseFloat(e.finishRate);
                    return e;
                });
                // orgDataArr = orgDataArr.filter(e => e.finishRate != 0);

                let rateSet = new Set(orgDataArr.map(e => e.finishRate));  //所有数据中心不重复的工单完成率排序

                orgDataArr.map(e => {
                    e.finishRate = e.finishRate + '%';
                });

                let sortedRateArr1 = (Array.from(rateSet)).sort((a, b) => a > b ? 1 : a < b ? -1 : 0).reverse();
                sortedRateArr1 = sortedRateArr1.map(e => {
                    return e + '%';
                });
                [this.topFirst, this.topSecond, this.topThird] = this.getTopLastThreeArrOper(sortedRateArr1, orgDataArr);
                let sortedRateArr2 = (Array.from(rateSet)).sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
                sortedRateArr2 = sortedRateArr2.map(e => {
                    return e + '%';
                });
                [this.lastFirst, this.lastSecond, this.lastThird] = this.getTopLastThreeArrOper(sortedRateArr2, orgDataArr);
            },

            getTopLastThreeArrOper(sortedRateArr, orgDataArr) {
                let first = [];
                let second = [];
                let third = [];
                for (let i = 0; i < sortedRateArr.length; i++) {
                    for (let j = 0; j < orgDataArr.length; j++) {
                        if (sortedRateArr[i] == orgDataArr[j].finishRate && i == 0) {
                            first.push(orgDataArr[j].dcnumName + ':' + orgDataArr[j].finishRate);
                        } else if (sortedRateArr[i] == orgDataArr[j].finishRate && i == 1) {
                            second.push(orgDataArr[j].dcnumName + ':' + orgDataArr[j].finishRate);
                        } else if (sortedRateArr[i] == orgDataArr[j].finishRate && i == 2) {
                            third.push(orgDataArr[j].dcnumName + ':' + orgDataArr[j].finishRate);
                        }
                    }
                }
                return [first, second, third];
            },

            renderChart(dcnumNames, totalAll, month) {
                let myChart = echarts.init(this.$refs.completionChart);
                let option = {
                    title: {
                        text: `数据中心${month}月份作业工单完成情况`,
                        textStyle: {
                            align: 'center',
                            color: '#000',
                            fontSize: 14,
                        },
                        top: '0',
                        left: 'center'
                    },
                    color: ['#13d06c'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        formatter: '{c}%',
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    dataZoom: [{
                        type: 'slider',
                        show: true,
                        xAxisIndex: [0],
                        end: 50
                    },
                    {
                        type: 'inside',
                        xAxisIndex: [0],
                        start: 0,
                        end: 100
                    },
                    ],
                    xAxis: [
                        {
                            type: 'category',
                            data: dcnumNames,
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: "#333",
                                    fontSize: 12
                                },
                                interval: 0,
                                rotate: 30
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            type: 'bar',
                            barWidth: 30,
                            label: {
                                normal: {
                                    show: true,
                                    fontSize: 14,
                                    fontWeight: 'normal',
                                    color: '#000',
                                    position: 'top',
                                }
                            },
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        position: 'top',
                                        formatter: '{c}%'
                                    }
                                }
                            },
                            data: totalAll,
                        }
                    ]
                };
                myChart.setOption(option);
            }
        },

        mounted() {

        },

        created() {
            that = this;
        },

        watch: {

            dcnumids: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal != '') {
                        this.query();
                    }
                }
            },

            searchDate: {
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal != '') {
                        this.query();
                    }
                }
            },

        },
    }
</script>

<style scoped>

</style>